import React from 'react'
import { useSelector } from 'react-redux'
import { eventSelector, eventModalSelector, chatSelector } from 'src/selectors'

import EventInformation from './EventInformation'
import EventChat from './EventChat/EventChat'
import GuestsListPage from './GuestsListPage/GuestsListPage'
import MediaPage from '../../../../MediaPage'
import OrdersPage from '../../../../OrdersPage'
import OrderDetailPage from '../../../../OrderDetailPage'
import RequestRefundPage from '../../../../RequestRefundPage'
import AddGuestsPage from './AddGuestsPage/AddGuestsPageContainer'
import OpenInAppModal from 'src/components/OpenInAppModal'
import PropTypes from 'prop-types'

const EventSection = (props) => {
  const event = useSelector(eventSelector)
  const eventModal = useSelector(eventModalSelector)
  const { socketInstance } = useSelector(chatSelector)

  const getCurComponent = () => {
    if (eventModal === 'chat' && !socketInstance) {
      return <EventInformation onRetryFlyerUpload={props.onRetryFlyerUpload} />
    }

    const components = {
      details: <EventInformation onRetryFlyerUpload={props.onRetryFlyerUpload} />,
      guests: <GuestsListPage />,
      media: <MediaPage />,
      chat: <EventChat />,
      orders: <OrdersPage />,
      orderDetail: <OrderDetailPage />,
      requestRefund: <RequestRefundPage />,
      addGuests: <AddGuestsPage />
    }
    let curComponent = components[eventModal]

    return curComponent || components['details']
  }

  return (
    <div style={{ height: '100%', overflow: 'hidden' }}>
      {getCurComponent()}
      <OpenInAppModal event={event} />
    </div>
  )
}

EventSection.propTypes = {
  onRetryFlyerUpload: PropTypes.func
}

export default EventSection
